import { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

export function useUsers() {
  return useQuery({
    queryKey: ["users"],
    queryFn: async () => (await api.get("/users")).data,
  });
}

export function useClients() {
  return useQuery({
    queryKey: ["clients"],
    queryFn: async () => (await api.get("/clients")).data,
  });
}

export function useEventCategories() {
  return useQuery({
    queryKey: ["event-categories"],
    queryFn: async () => (await api.get("/events/categories")).data,
  });
}

export function useProjects(params = {}) {
  return useQuery({
    queryKey: ["projects", params],
    queryFn: async () => (await api.get("/projects", { params })).data,
  });
}

export function useDayToday() {
  return useQuery({
    queryKey: ["day-log", "today"],
    queryFn: async () => (await api.get("/day-logs/today")).data,
  });
}

/** A interação (cronómetro por cliente) em curso do utilizador atual, se houver. */
/** Verdadeiro em ecrãs de telemóvel (o mesmo limite do `md:` do Tailwind). */
export function useIsMobile() {
  const query = "(max-width: 767px)";
  const [isMobile, setIsMobile] = useState(() => window.matchMedia(query).matches);
  useEffect(() => {
    const media = window.matchMedia(query);
    const onChange = (changeEvent) => setIsMobile(changeEvent.matches);
    media.addEventListener("change", onChange);
    setIsMobile(media.matches);
    return () => media.removeEventListener("change", onChange);
  }, []);
  return isMobile;
}

export function useActiveInteraction() {
  return useQuery({
    queryKey: ["interaction-active"],
    queryFn: async () => (await api.get("/interactions/active")).data,
    // O tempo em si é calculado no cliente a partir de startedAt; isto é só
    // reconciliação de fundo (ex.: se a interação foi parada noutro separador).
    refetchInterval: 60000,
  });
}

/** Segundos decorridos desde `startedAt` (ISO), a ganhar +1 por segundo. */
export function useElapsedSeconds(startedAt) {
  const [seconds, setSeconds] = useState(() => (startedAt ? (Date.now() - new Date(startedAt).getTime()) / 1000 : 0));
  useEffect(() => {
    if (!startedAt) return undefined;
    const started = new Date(startedAt).getTime();
    setSeconds((Date.now() - started) / 1000);
    const id = setInterval(() => setSeconds((Date.now() - started) / 1000), 1000);
    return () => clearInterval(id);
  }, [startedAt]);
  return Math.max(0, seconds);
}

export function userMap(users) {
  const m = {};
  (users || []).forEach((u) => (m[u.id] = u));
  return m;
}

export function clientMap(clients) {
  const m = {};
  (clients || []).forEach((c) => (m[c.id] = c));
  return m;
}
